import { cloneIconElement } from "@taroify/icons/utils/index.js";
import { View } from "@tarojs/components";
import classNames from "classnames";
import * as React from "react";
import { useContext } from "react";
import { prefixClassname } from "../styles/index.js";
import { addUnitPx } from "../utils/format/unit.js";
import RateContext from "./rate.context.js";
import { RateStatus } from "./rate.shared.js";
function RateItem(props) {
    const { className, style, score, value, half, disabled, size, status, ...restProps } = props;
    const { gutter, count, emptyIcon, icon } = useContext(RateContext);
    const empty = status === RateStatus.Void;
    const full = status === RateStatus.Full;
    return (React.createElement(View, { className: classNames(prefixClassname("rate__item"), className), style: {
            paddingRight: score !== count ? addUnitPx(gutter) : "",
            ...style,
        }, ...restProps },
        cloneIconElement(full ? icon : emptyIcon, {
            size,
            className: classNames(prefixClassname("rate__icon"), {
                [prefixClassname("rate__icon--disabled")]: disabled,
                [prefixClassname("rate__icon--full")]: full,
            }),
        }),
        half &&
            cloneIconElement(icon, {
                style: { width: `${value}em` },
                size,
                className: classNames(prefixClassname("rate__icon"), prefixClassname("rate__icon--half"), {
                    [prefixClassname("rate__icon--disabled")]: disabled,
                    [prefixClassname("rate__icon--full")]: !empty,
                }),
            })));
}
export default RateItem;
